import AdminGuard from '@/views/dashboard/guards/AdminGuard'
import User from './User'

export default [
    {
        path: 'pengguna',
        component: User,
        name: 'user.index',
        beforeEnter: AdminGuard,
        meta: {
            title: 'Pengguna'
        }
    }
]
